import React, { ReactNode } from 'react';
import Col from '../../../foundational/Layout/Col';
import resolvedClassName from '../../../utils/resolvedClassName';
import { IHeaderProps } from '../Header';

interface IHeaderLogoContainerProps {
	children: ReactNode;
	centeredLogo: IHeaderProps['centeredLogo'];
	navBarLinks: IHeaderProps['navBarLinks'];
	customMessage: IHeaderProps['customMessage'];
}

export default function HeaderLogoContainer({
	children,
	centeredLogo,
	navBarLinks,
	customMessage,
}: Readonly<IHeaderLogoContainerProps>) {
	return (
		<Col
			className={resolvedClassName(
				'Header__logo',
				centeredLogo &&
					navBarLinks?.length === 0 &&
					'Header__logo--centered',
			)}
			xs={Boolean(customMessage)}
		>
			{children}
		</Col>
	);
}
